import { useCallback, useEffect, useState } from "react";
import { verifyGaragePassword } from "../../api/garageAuth";
import { C, FETCH_FN, DELETE_FN, CREATE_FN, UPDATE_FN, REQUIRED, INVENTORY_CONFIG, FORM_TITLES, useInventory, extractList, fmtPrice, Badge, PrimaryBtn, OutlineBtn, DeleteBtn, DrawerShell, AvatarCircle, Field, FInput, FTextarea, FSelect, Divider, Grid2, Grid3, Card, TH, TD, Msg } from "./common";
function CarsTable({ data, onView }) {
  return (
    <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 12 }}>
      <thead>
        <tr>
          {["Vehicle", "Year", "Condition", "Mileage", "Price", "Status", "Actions"].map(h => (
            <th key={h} style={{ textAlign: "left", padding: "0 12px 10px", fontSize: 10, fontWeight: 600, color: C.muted, textTransform: "uppercase", letterSpacing: ".06em", whiteSpace: "nowrap" }}>{h}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {data.map(car => (
          <tr key={car.id} style={{ borderTop: `1px solid ${C.border}` }}>
            <td style={{ padding: "10px 12px", fontWeight: 600, fontSize: 12 }}>{car.make} {car.model}</td>
            <td style={{ padding: "10px 12px", fontSize: 12 }}>{car.year}</td>
            <td style={{ padding: "10px 12px", fontSize: 12 }}>{car.condition}</td>
            <td style={{ padding: "10px 12px", fontSize: 12 }}>{Number(car.mileage || 0).toLocaleString()} km</td>
            <td style={{ padding: "10px 12px", fontWeight: 600, fontSize: 12 }}>
              {car.currency === "USD" ? "$" : "KSh "}{Number(car.price || 0).toLocaleString()}
            </td>
            <td style={{ padding: "10px 12px" }}><Badge status={car.status || "Available"} /></td>
            <td style={{ padding: "10px 12px" }}>
              <div style={{ display: "flex", gap: 6 }}>
                <OutlineBtn onClick={() => onView(car)}>View</OutlineBtn>
              </div>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

function SparesTable({ data, onView }) {
  return (
    <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 12 }}>
      <thead>
        <tr>
          {["Part name", "Category", "SKU", "Manufacturer", "Price", "In stock", "Actions"].map(h => (
            <th key={h} style={{ textAlign: "left", padding: "0 12px 10px", fontSize: 10, fontWeight: 600, color: C.muted, textTransform: "uppercase", letterSpacing: ".06em", whiteSpace: "nowrap" }}>{h}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {data.map(p => (
          <tr key={p.id} style={{ borderTop: `1px solid ${C.border}` }}>
            <td style={{ padding: "10px 12px", fontWeight: 600, fontSize: 12 }}>{p.name}</td>
            <td style={{ padding: "10px 12px", fontSize: 12 }}>{p.category}</td>
            <td style={{ padding: "10px 12px" }}>
              <span style={{ fontFamily: "monospace", fontSize: 11, background: "#f1f5f9", padding: "2px 6px", borderRadius: 4 }}>{p.sku || "—"}</span>
            </td>
            <td style={{ padding: "10px 12px", fontSize: 12 }}>{p.manufacturer || "—"}</td>
            <td style={{ padding: "10px 12px", fontWeight: 600, fontSize: 12 }}>
              {p.currency === "USD" ? "$" : "KSh "}{Number(p.price || 0).toLocaleString()}
            </td>
            <td style={{ padding: "10px 12px" }}>
              <span style={{ fontWeight: 700, color: (p.quantity ?? 0) < 10 ? C.red : C.green }}>
                {p.quantity ?? 0}
              </span>
            </td>
            <td style={{ padding: "10px 12px" }}>
              <div style={{ display: "flex", gap: 6 }}>
                <OutlineBtn onClick={() => onView(p)}>View</OutlineBtn>
              </div>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}


function AccessoriesTable({ data, onView }) {
  return (
    <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 12 }}>
      <thead>
        <tr>
          {["Product", "Category", "Brand", "Price", "Stock", "Actions"].map(h => (
            <th key={h} style={{ textAlign: "left", padding: "0 12px 10px", fontSize: 10, fontWeight: 600, color: C.muted, textTransform: "uppercase", letterSpacing: ".06em", whiteSpace: "nowrap" }}>{h}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {data.map(a => (
          <tr key={a.id} style={{ borderTop: `1px solid ${C.border}` }}>
            <td style={{ padding: "10px 12px", fontWeight: 600, fontSize: 12 }}>{a.name || a.title}</td>
            <td style={{ padding: "10px 12px", fontSize: 12 }}>{a.category}</td>
            <td style={{ padding: "10px 12px", fontSize: 12 }}>{a.brand}</td>
            <td style={{ padding: "10px 12px", fontWeight: 600, fontSize: 12 }}>
              {a.currency === "USD" ? "$" : "KSh "}{Number(a.price || 0).toLocaleString()}
            </td>
            <td style={{ padding: "10px 12px" }}>
              <span style={{ fontWeight: 700, color: (a.stock ?? a.quantity ?? 0) < 6 ? C.red : C.green }}>
                {a.stock ?? a.quantity ?? 0}
              </span>
            </td>
            <td style={{ padding: "10px 12px" }}>
              <div style={{ display: "flex", gap: 6 }}>
                <OutlineBtn onClick={() => onView(a)}>View</OutlineBtn>
              </div>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

function MechanicsTable({ data, onView }) {
  return (
    <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 12 }}>
      <thead>
        <tr>
          {["Name", "Specialty", "Phone", "Jobs done", "Status", "Actions"].map(h => (
            <th key={h} style={{ textAlign: "left", padding: "0 12px 10px", fontSize: 10, fontWeight: 600, color: C.muted, textTransform: "uppercase", letterSpacing: ".06em", whiteSpace: "nowrap" }}>{h}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {data.map(m => (
          <tr key={m.id} style={{ borderTop: `1px solid ${C.border}` }}>
            <td style={{ padding: "10px 12px" }}>
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <AvatarCircle name={m.name} />
                <span style={{ fontWeight: 600, fontSize: 12 }}>{m.name}</span>
              </div>
            </td>
            <td style={{ padding: "10px 12px", fontSize: 12 }}>{m.specialty}</td>
            <td style={{ padding: "10px 12px", fontSize: 12 }}>{m.phone}</td>
            <td style={{ padding: "10px 12px", fontSize: 12, fontWeight: 600 }}>{m.jobsDone ?? m.jobs_done ?? 0}</td>
            <td style={{ padding: "10px 12px" }}><Badge status={m.status} /></td>
            <td style={{ padding: "10px 12px" }}>
              <div style={{ display: "flex", gap: 6 }}>
                <OutlineBtn onClick={() => onView(m)}>View</OutlineBtn>
              </div>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

const TABLE_COMPONENT = {
  cars:        CarsTable,
  hire:        CarsTable,
  spares:      SparesTable,
  accessories: AccessoriesTable,
  mechanics:   MechanicsTable,
};


// ── InventorySection ───────────────────────────────────────────
function InventorySection({ tab, registerExport }) {
  const cfg = INVENTORY_CONFIG[tab];
  const { data, loading, error, reload } = useInventory(FETCH_FN[tab]);
  const [drawer, setDrawer] = useState(null); // { record? }
  const [detail, setDetail] = useState(null);

  useEffect(() => { registerExport(cfg.label, data); }, [data, cfg.label, registerExport]);

  const handleDelete = useCallback(async (id, name) => {
    const password = window.prompt("Re-enter your garage login password to continue.");
    if (!(await verifyGaragePassword(password))) { alert("Password verification failed."); return; }
    if (!window.confirm(`Delete "${name}"? This cannot be undone.`)) return;
    try {
      await DELETE_FN[tab](id);
      reload();
    } catch (err) {
      alert(err.message || "Delete failed.");
    }
  }, [tab, reload]);

  const noun  = tab === "mechanics" ? "mechanics" : "listings";
  const Table = TABLE_COMPONENT[tab];

  const renderTable = () => {
    if (loading) return <Msg>Loading {cfg.label.toLowerCase()}...</Msg>;
    if (error)   return <Msg color={C.red}>Error: {error}</Msg>;
    if (!data.length) return <Msg>No {noun} found. Add one to get started.</Msg>;
    return <Table data={data} onView={(record) => setDetail(record)} />;
  };

  useEffect(() => {
    const handler = async () => {
      if (!detail) { alert("Select a record with View first."); return; }
      const choice = window.prompt("Advanced tools: type edit or delete.");
      if (choice === "edit") {
        const password = window.prompt("Re-enter your garage login password to continue.");
        if (await verifyGaragePassword(password)) setDrawer({ record: detail });
        else alert("Password verification failed.");
      }
      if (choice === "delete") handleDelete(detail.id, detail.name || detail.title || detail.make || "record");
    };
    window.addEventListener("garage-advanced-tools", handler);
    return () => window.removeEventListener("garage-advanced-tools", handler);
  }, [detail, handleDelete]);

  return (
    <div className="page-section">
      <div className="page-heading">
        <div>
          <h2 style={{ fontSize: 22, fontWeight: 700, color: C.text, margin: 0 }}>{cfg.label}</h2>
          <p style={{ fontSize: 12, color: C.muted, margin: "4px 0 0" }}>
            {loading ? "Loading..." : `${data.length} ${noun} in the system`}
          </p>
        </div>
        <PrimaryBtn onClick={() => setDrawer({})}>{cfg.addLabel}</PrimaryBtn>
      </div>
      <div className="table-shell">
        {renderTable()}
      </div>
      {drawer && (
        <InventoryDrawer
          type={cfg.type}
          record={drawer.record}
          onClose={(saved) => { setDrawer(null); if (saved) reload(); }}
        />
      )}
      {detail && <div className="garage-detail-fullscreen" role="dialog">
        <div className="garage-detail-card">
          <div className="garage-detail-header"><h2>{cfg.label} detail</h2><OutlineBtn onClick={() => setDetail(null)}>Close</OutlineBtn></div>
          <dl>{Object.entries(detail).filter(([, v]) => v == null || typeof v !== "object").map(([k, v]) => <div key={k}><dt>{k}</dt><dd>{String(v ?? "—")}</dd></div>)}</dl>
        </div>
      </div>}
    </div>
  );
}


// ── Add listing forms ──────────────────────────────────────────
const MAKES       = ["Toyota","Nissan","Subaru","Mazda","Honda","Mercedes","BMW","Ford","Mitsubishi","Volkswagen","Hyundai","Kia"];
const SPECIALTIES = ["Engine & Transmission","Electrical & Electronics","Brakes & Suspension","Body & Paint","AC & Cooling","Diagnostics","General mechanic"];

function VehicleForm({ form, set }) {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
      <Divider title="Vehicle details" />
      <Grid2>
        <Field label="Make" required>
          <FSelect value={form.make} onChange={e => set("make", e.target.value)}>
            <option value="">Select make</option>
            {MAKES.map(m => <option key={m}>{m}</option>)}
          </FSelect>
        </Field>
        <Field label="Model" required>
          <FInput placeholder="e.g. Land Cruiser" value={form.model} onChange={e => set("model", e.target.value)} />
        </Field>
        <Field label="Year" required>
          <FInput type="number" placeholder="e.g. 2021" value={form.year} onChange={e => set("year", e.target.value)} />
        </Field>
        <Field label="Condition" required>
          <FSelect value={form.condition} onChange={e => set("condition", e.target.value)}>
            <option value="">Select</option>
            {["New","Used","Certified Pre-owned"].map(c => <option key={c}>{c}</option>)}
          </FSelect>
        </Field>
        <Field label="Body type">
          <FSelect value={form.bodyType} onChange={e => set("bodyType", e.target.value)}>
            <option value="">Select</option>
            {["Sedan","SUV","Hatchback","Pickup","Van","Coupe"].map(b => <option key={b}>{b}</option>)}
          </FSelect>
        </Field>
        <Field label="Mileage (km)">
          <FInput type="number" placeholder="e.g. 45000" value={form.mileage} onChange={e => set("mileage", e.target.value)} />
        </Field>
        <Field label="Transmission">
          <FSelect value={form.transmission} onChange={e => set("transmission", e.target.value)}>
            <option value="">Select</option>
            {["Automatic","Manual"].map(t => <option key={t}>{t}</option>)}
          </FSelect>
        </Field>
        <Field label="Fuel type">
          <FSelect value={form.fuelType} onChange={e => set("fuelType", e.target.value)}>
            <option value="">Select</option>
            {["Petrol","Diesel","Electric","Hybrid"].map(f => <option key={f}>{f}</option>)}
          </FSelect>
        </Field>
        <Field label="Colour">
          <FInput placeholder="e.g. Pearl White" value={form.color} onChange={e => set("color", e.target.value)} />
        </Field>
        <Field label="Location" required>
          <FSelect value={form.location} onChange={e => set("location", e.target.value)}>
            <option value="">Select</option>
            {["Nairobi","Mombasa","Kisumu","Nakuru","Eldoret"].map(l => <option key={l}>{l}</option>)}
          </FSelect>
        </Field>
      </Grid2>
      <Divider title="Pricing" />
      <Grid2>
        <Field label="Currency">
          <FSelect value={form.currency} onChange={e => set("currency", e.target.value)}>
            <option>KES</option><option>USD</option>
          </FSelect>
        </Field>
        <Field label="Price" required>
          <FInput type="number" placeholder="e.g. 2400000" value={form.price} onChange={e => set("price", e.target.value)} />
        </Field>
        <Field label="Badge">
          <FSelect value={form.badge} onChange={e => set("badge", e.target.value)}>
            <option value="">None</option>
            {["New arrival","Hot deal","Featured","Sold"].map(b => <option key={b}>{b}</option>)}
          </FSelect>
        </Field>
      </Grid2>
      <Divider title="Description & features" />
      <Field label="Description">
        <FTextarea placeholder="Describe the vehicle history and condition..." value={form.description} onChange={e => set("description", e.target.value)} />
      </Field>
      <Field label="Features" hint="Comma-separated: Sunroof, Reverse camera, Leather seats">
        <FInput placeholder="Sunroof, Leather seats, Apple CarPlay..." value={form.features} onChange={e => set("features", e.target.value)} />
      </Field>
    </div>
  );
}

function SpareForm({ form, set }) {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
      <Divider title="Part details" />
      <Grid2>
        <Field label="Category" required>
          <FSelect value={form.category} onChange={e => set("category", e.target.value)}>
            <option value="">Select</option>
            {["Engine","Brakes","Suspension","Electrical","Body","Ignition","Transmission","Cooling"].map(c => <option key={c}>{c}</option>)}
          </FSelect>
        </Field>
        <Field label="Part name" required>
          <FInput placeholder="e.g. Engine Oil Filter" value={form.name} onChange={e => set("name", e.target.value)} />
        </Field>
        <Field label="SKU / Part number" hint="OEM or stock code">
          <FInput placeholder="e.g. OEM-1234567" value={form.sku} onChange={e => set("sku", e.target.value)} />
        </Field>
        <Field label="Manufacturer">
          <FInput placeholder="e.g. Toyota" value={form.manufacturer} onChange={e => set("manufacturer", e.target.value)} />
        </Field>
        <Field label="Supplier">
          <FInput placeholder="e.g. Auto Parts Nairobi" value={form.supplier} onChange={e => set("supplier", e.target.value)} />
        </Field>
      </Grid2>
      <Divider title="Stock & pricing" />
      <Grid3>
        <Field label="Currency">
          <FSelect value={form.currency} onChange={e => set("currency", e.target.value)}>
            <option>KES</option><option>USD</option>
          </FSelect>
        </Field>
        <Field label="Price" required>
          <FInput type="number" placeholder="e.g. 3500" value={form.price} onChange={e => set("price", e.target.value)} />
        </Field>
        <Field label="Quantity" required>
          <FInput type="number" placeholder="e.g. 50" value={form.quantity} onChange={e => set("quantity", e.target.value)} />
        </Field>
      </Grid3>
      <Divider title="Description" />
      <Field label="Description">
        <FTextarea placeholder="Condition, compatibility, and any other details..." value={form.description} onChange={e => set("description", e.target.value)} />
      </Field>
    </div>
  );
}

function AccessoryForm({ form, set }) {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
      <Divider title="Product details" />
      <Grid2>
        <Field label="Category" required>
          <FSelect value={form.category} onChange={e => set("category", e.target.value)}>
            <option value="">Select</option>
            {["Audio","Safety","Interior","Exterior","Lighting","Performance","Navigation"].map(c => <option key={c}>{c}</option>)}
          </FSelect>
        </Field>
        <Field label="Brand" required>
          <FInput placeholder="e.g. Pioneer" value={form.brand} onChange={e => set("brand", e.target.value)} />
        </Field>
        <Field label="Product name" required>
          <FInput placeholder="e.g. Pioneer DMH-WT8600" value={form.title} onChange={e => set("title", e.target.value)} />
        </Field>
        <Field label="SKU">
          <FInput placeholder="e.g. PI-HU-WT8600" value={form.sku} onChange={e => set("sku", e.target.value)} />
        </Field>
      </Grid2>
      <Divider title="Stock & pricing" />
      <Grid3>
        <Field label="Currency">
          <FSelect value={form.currency} onChange={e => set("currency", e.target.value)}>
            <option>KES</option><option>USD</option>
          </FSelect>
        </Field>
        <Field label="Price" required>
          <FInput type="number" placeholder="e.g. 28000" value={form.price} onChange={e => set("price", e.target.value)} />
        </Field>
        <Field label="Stock" required>
          <FInput type="number" placeholder="e.g. 10" value={form.stock} onChange={e => set("stock", e.target.value)} />
        </Field>
      </Grid3>
      <Divider title="Description" />
      <Field label="Compatible with" hint="e.g. Universal fit, DIN 2 slot">
        <FInput placeholder="Toyota Corolla 2015-2022, Universal..." value={form.compatibility} onChange={e => set("compatibility", e.target.value)} />
      </Field>
      <Field label="Description">
        <FTextarea placeholder="Describe the product and what's included..." value={form.description} onChange={e => set("description", e.target.value)} />
      </Field>
    </div>
  );
}

function MechanicForm({ form, set }) {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
      <Divider title="Mechanic details" />
      <Grid2>
        <Field label="Full name" required>
          <FInput placeholder="e.g. James Mwangi" value={form.name} onChange={e => set("name", e.target.value)} />
        </Field>
        <Field label="Phone" required>
          <FInput placeholder="+254 7XX XXX XXX" value={form.phone} onChange={e => set("phone", e.target.value)} />
        </Field>
        <Field label="Specialty" required>
          <FSelect value={form.specialty} onChange={e => set("specialty", e.target.value)}>
            <option value="">Select</option>
            {SPECIALTIES.map(s => <option key={s}>{s}</option>)}
          </FSelect>
        </Field>
        <Field label="Status">
          <FSelect value={form.status} onChange={e => set("status", e.target.value)}>
            {["Active","Off duty","On leave"].map(s => <option key={s}>{s}</option>)}
          </FSelect>
        </Field>
        <Field label="Experience (years)">
          <FInput type="number" placeholder="e.g. 5" value={form.experience} onChange={e => set("experience", e.target.value)} min="0" />
        </Field>
        <Field label="National ID">
          <FInput placeholder="ID number" value={form.idNumber} onChange={e => set("idNumber", e.target.value)} />
        </Field>
      </Grid2>
      <Divider title="Additional info" />
      <Field label="Notes">
        <FTextarea placeholder="Any additional notes..." value={form.notes} onChange={e => set("notes", e.target.value)} />
      </Field>
    </div>
  );
}

const FORM_DEFAULTS = {
  vehicle:   { make:"", model:"", year:"", condition:"", bodyType:"", mileage:"", transmission:"", fuelType:"", color:"", currency:"KES", price:"", location:"", badge:"", description:"", features:"" },
  spare:     { category:"", name:"", sku:"", manufacturer:"", supplier:"", currency:"KES", price:"", quantity:"", description:"" },
  accessory: { category:"", brand:"", title:"", sku:"", currency:"KES", price:"", stock:"", compatibility:"", description:"" },
  mechanic:  { name:"", phone:"", specialty:"", status:"Active", experience:"", idNumber:"", notes:"" },
};

const FORM_COMPONENT = {
  vehicle: VehicleForm, spare: SpareForm,
  accessory: AccessoryForm, mechanic: MechanicForm,
};

// ── Inventory add / edit drawer ────────────────────────────────
function InventoryDrawer({ type, record, onClose }) {
  const defaults = FORM_DEFAULTS[type];
  const [form, setForm] = useState(() => {
    if (!record) return { ...defaults };
    return Object.fromEntries(Object.keys(defaults).map(k => {
      const v = record[k];
      return [k, Array.isArray(v) ? v.join(", ") : (v ?? defaults[k])];
    }));
  });
  const setField = (key, val) => setForm(f => ({ ...f, [key]: val }));

  const handleSubmit = async () => {
    const missing = REQUIRED[type].find(k => form[k] === "" || form[k] == null);
    if (missing) throw new Error(`Please fill in the required field: ${missing}.`);
    return record ? UPDATE_FN[type](record.id, form) : CREATE_FN[type](form);
  };

  const FormComponent = FORM_COMPONENT[type] || VehicleForm;
  const noun = FORM_TITLES[type].replace("Add ", "");

  return (
    <DrawerShell
      title={record ? `Edit ${noun}` : FORM_TITLES[type]}
      submitLabel={record ? "Save changes" : `Save ${noun}`}
      onSubmit={handleSubmit}
      onClose={onClose}
    >
      <FormComponent form={form} set={setField} />
    </DrawerShell>
  );
}

// ── Config-driven forms (bookings, work orders, quotes, ...) ───

export { InventorySection };
